import script from "./StudentResults.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentResults.vue?vue&type=script&setup=true&lang=js"

import "./StudentResults.vue?vue&type=style&index=0&id=6cb44b96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb44b96"]])

export default __exports__